import styled from 'styled-components/macro'
import { theme } from 'styled-tools'
// import { media } from '../../../ui/rwd'
import { Button as ButtonBase } from 'reactstrap'

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
  border: 0;
  box-shadow: 0px 0px 8px 2px rgba(0, 0, 0, 0.15);
  width: 100%;
  min-height: 50px;
  border-radius: 5px;
  padding: 2em;
  font-size: 80%;
  background: ${theme('storeIdBox')};
  &:hover {
    box-shadow: 0px 0px 8px 2px rgba(0, 0, 0, 0.22);
  }
`

const Text = styled.span`
  color: ${theme('storeIdText')};
`
const Button = styled(ButtonBase)`
  &.btn {
    min-width: 105px;
    height: 100%;
    align-self: flex-end;
    background: ${theme('storeIdBox')} !important;
    border: 1px solid;
    border-color: ${theme('storeIdText')} !important;
    color: ${theme('storeIdText')} !important;
  }
`
const InstagramHandle = styled.a`
  color: ${theme('storeIdText')} !important;
  font-weight: 900;
`

export { Container, Text, Button, InstagramHandle }
